import { Component } from 'react';

/**
 * Error Boundary per catturare errori React e mostrare fallback pulito.
 * MAI mostra template/demo - solo pagina di errore minimale.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <h1 className="text-6xl font-bold text-muted-foreground mb-4">500</h1>
            <h2 className="text-xl font-medium mb-4">Si è verificato un errore</h2>
            <p className="text-muted-foreground mb-6">
              Ci scusiamo per l&apos;inconveniente. Prova a ricaricare la pagina.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-primary text-primary-foreground rounded hover:opacity-90 transition"
            >
              Ricarica pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
